import { ComponentStyleConfig } from '@chakra-ui/react';

const Drawer: ComponentStyleConfig = {
  baseStyle: {
    dialogContainer: { zIndex: '996' },
  },
};

export default Drawer;
